<template>
  <div class="childbox1 relative" id="app">
    <div class="chart_box3 dn-content-bg">
      <div class="top">{{ pie.titleTime }}</div>
      <div class="box dn-content-bg" :id="echartsId" ref="tapp"></div>
    </div>
  </div>
</template>

<script>
import uuidv1 from "uuid/v1";
export default {
  name: "",
  props: {
    pie: {
      type: [Object, Array],
      default: () => {
        return {};
      },
    },
    carouselIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      bg_color1: "#4da6ff",
      btnNum: "one",
      myChart: null,
      dateType1: "",
      echartsId: uuidv1(),
    };
  },
  watch: {
    pie: {
      handler(newval, oldval) {
        this.fillPie(this.pie);
      },
      deep: true,
    },
    carouselIndex(newval, oldval) {
      this.myChart.resize();
    },
  },
  mounted() {
    this.fillPie(this.pie);
  },
  methods: {
    fillPie(data) {
      let colorList = [
        "#E86F59",
        "#88D0FB",
        "#DB70D7",
        "#32CD32",
        "#6299EC",
        "#FF68B5",
        "#BB54D3",
        "#E86F59",
        "#FFA709",
      ];
      this.myChart = this.$echarts.init(
        document.getElementById(this.echartsId),
        { height: 246 }
      );
      let option = {
        title: {
          // text: data.title,
          x: "center",
          y: "center",
          textStyle: {
            fontSize: 20,
          },
        },
        // color:['#73DDFF', '#73ACFF', '#FDD56A', '#FDB36A', '#FD866A', '#9E87FF', '#58D5FF'],
        grid: {
          bottom: "21%",
          left: "5%",
          right: "5%",
          top: "2%",
          containLabel: true,
        },
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b}: {d}%"
          formatter: "{a} <br/>{b}: {c}%",
        },
        legend: {
          orient: "vertical",
          left: 60,
          top: "center",
          data: data.legend,
        },
        series: [
          {
            name: "负载率百分比",
            // type: "pie",
            // radius: "46%",
            type: "pie",
            center: ["50%", "50%"],
            radius: ["50%", "80%"],
            clockwise: true,
            avoidLabelOverlap: true,
            hoverOffset: 15,
            itemStyle: {
              normal: {
                color: function (params) {
                  return colorList[params.dataIndex];
                },
              },
            },
            label: {
              show: false,
              position: "outside",
              formatter: "{a|{b}：{d}%}\n{hr|}",
              rich: {
                hr: {
                  backgroundColor: "t",
                  borderRadius: 3,
                  width: 3,
                  height: 3,
                  padding: [3, 3, 0, -12],
                },
                a: {
                  padding: [-30, 15, -20, 15],
                },
              },
            },
            labelLine: {
              normal: {
                length: 20,
                length2: 30,
                lineStyle: {
                  width: 1,
                },
              },
            },
            data: data.data,
          },
        ],
      };
      this.myChart.setOption(option, true);
      let this_ = this;
      window.addEventListener("resize", function () {
        this_.myChart.resize();
      });
    },
    resizeEcharts() {
      if (
        this.myChart != null &&
        this.myChart != "" &&
        this.myChart != undefined
      ) {
        this.myChart.resize();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  flex: 1;
  overflow: hidden;
}
.flex {
  flex: 1;
  padding: 5px;
}
.childbox1 {
  width: 100%;
  height: 100%;
  background: #fff;
  flex: 1;
  box-sizing: border-box;
  padding: 0px;
  margin-bottom: 10px;
  box-sizing: border-box;
  border-top: 1px solid #ccc;
}
.relative {
  position: relative;
}
.title_btn {
  height: 58px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  background: #dbdbdb;
}
.title_btn {
  .titdiv {
    flex: 1;
    font-size: 18px;
    font-weight: bold;
    color: #333;
    border-bottom: 1px solid #dedcdc;
    padding-left: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}
.engTitle {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.title_btn button {
  height: 100%;
  text-align: center;
  float: left;
  line-height: 58px;
  padding: 0 10px;
  font-size: 14px;
  background: #dbdbdb;
  color: #000;
  font-weight: bold;
  border: 1px solid #dedcdc;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 0 !important;
  margin: 0 !important;
  border: none;
  border-bottom: 1px solid #dedcdc;
}
.title_btn .active {
  color: #1d6ce9;
  border-color: #dddddd;
  border-bottom: 6px solid #1d6ce9;
  font-weight: bold;
}
.btn_box {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
}
.chart_box3 {
  position: absolute;
  top: 0px;
  bottom: 0;
  width: 100%;
  padding: 5px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  .top {
    padding: 5px;
    font-size: 20px;
    color: #666;
    text-align: center;
    box-sizing: border-box;
  }
}
.btn_box >>> .el-button {
  margin: 0 !important;
  border-radius: 0 !important;
}
</style>